/**
* hero carousel banner and promotion bar slider code ( Start ).
* Initializes a slider within a given container element.
*
* @param {HTMLElement} container The parent element containing the slider.
* @param {string} nextButtonSelector CSS selector for the "next" button.
* @param {string} prevButtonSelector CSS selector for the "previous" button.
* @param {string} slidesSelector CSS selector for the slides container.
* @param {string} slideSelector CSS selector for individual slide elements.
*/
function initializeSlider(container, nextButtonSelector, prevButtonSelector, slidesSelector, slideSelector) {
  // Check if all required elements exist
  if ( container ) {
    let slides = container.querySelector(slidesSelector);
    let slideElements = container.querySelectorAll(slideSelector);
    let totalSlides = slideElements.length;
    let index = 1; // Start at the first actual slide
    let slideWidth = 100;
    let autoSlideInterval;

    // Clone first and last slides for seamless looping
    let firstClone = slideElements[0].cloneNode(true);
    let lastClone = slideElements[totalSlides - 1].cloneNode(true);

    slides.appendChild(firstClone);
    slides.prepend(lastClone);

    // Set initial position without animation
    slides.style.transition = "none";
    slides.style.transform = `translateX(${-index * slideWidth}%)`;

    
    function isValidDate(dateString) {
      const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})\s(0?[1-9]|1[0-2]):([0-5][0-9])\s([aApP][mM])$/;
    
      if (!regex.test(dateString)) return false;
    
      const [, mm, dd, yyyy, hh, min, meridian] = dateString.match(regex);
    
      // Convert to integers
      const month = parseInt(mm, 10);
      const day = parseInt(dd, 10);
      const year = parseInt(yyyy, 10);
      let hour = parseInt(hh, 10);
      const minute = parseInt(min, 10);
    
      if (meridian.toLowerCase() === "pm" && hour < 12) hour += 12;
      if (meridian.toLowerCase() === "am" && hour === 12) hour = 0;
    
      const date = new Date(year, month - 1, day, hour, minute);
    
      // Check if the date still matches the original components
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date.getHours() === hour &&
        date.getMinutes() === minute
      );
    }

    /**
     * timer functionality - Starts all countdowns immediately on page load
     */
    function startCountdownsForAllSlides() {
      const currentSlides = container.querySelectorAll(`${slideSelector}.original-slide`);
      currentSlides.forEach(slide => {
        const timerContainer = slide.querySelector('.promo-banner-countdown-timer-container');
        if (timerContainer) {
          startCountdownForSlideInstance(slide, timerContainer);
        }
      });
    }

    // Helper to create separate countdown for each timer
    function startCountdownForSlideInstance(slide, timerContainer) {
        const headingEl = slide.querySelector('.promo-banner-countdown-timer-heading');
        const errorEl = slide.querySelector('.timer-error-msg');
        const countdownContainer = slide.querySelector('.promo-banner-countdown-timer-container');
      
        // Show heading initially
        if (headingEl) headingEl.style.display = 'flex';
      
        const rawHtml = timerContainer.getAttribute('promo-date-end-time');
        if (!rawHtml) {
          if (errorEl) errorEl.style.display = 'flex';
          return;
        }
      
        // Extract plain text from the HTML-encoded date string
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawHtml;
        const dateStr = tempDiv.textContent.trim();
      
        const parsedDate = Date.parse(dateStr);
        if (!dateStr || isNaN(parsedDate)) {
          console.warn("Invalid date format:", dateStr);
          if (countdownContainer) countdownContainer.style.display = 'none';
          if (headingEl) headingEl.style.display = 'none';
          return;
        }
      
        const endTime = new Date(parsedDate).getTime();
      
        // Locate the text node inside the timer container that contains the date string
        const walker = document.createTreeWalker(timerContainer, NodeFilter.SHOW_TEXT, {
          acceptNode: node => node.nodeValue.trim().includes(dateStr) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
        });
      
        const textNode = walker.nextNode();
        if (!textNode) {
          console.warn("Countdown text node not found inside timerContainer.");
          return;
        }
        let timerInterval; // Declare this before using in updateCountdown
        // Timer update logic
        function updateCountdown() {
          const now = Date.now();
          const timeLeft = endTime - now;
      
          if (timeLeft <= 0) {
            clearInterval(timerInterval);
            if (headingEl) headingEl.style.display = 'none';
            return;
          }
      
          const hours = Math.floor(timeLeft / 3600000);
          const minutes = Math.floor((timeLeft % 3600000) / 60000);
          const seconds = Math.floor((timeLeft % 60000) / 1000);
      
          textNode.nodeValue = `${String(hours).padStart(2, '0')} h : ${String(minutes).padStart(2, '0')} m : ${String(seconds).padStart(2, '0')} s`;
        }
      
        // Kick off the countdown
        updateCountdown();
        timerInterval = setInterval(updateCountdown, 1000); // Assigned after function
      }

      if (totalSlides <= 1) {
        startCountdownsForAllSlides(); // Still start countdowns
        return;
      }
    
    /**
     * Displays the current slide with optional animation.
     *
     * @param {boolean} animated Whether to animate the transition (default: true).
     */
    function showSlide(animated = true) {
      slides.style.transition = animated ? "transform 0.9s ease-in-out" : "none";
      slides.style.transform = `translateX(${-index * slideWidth}%)`;
    }

    /**
     * Advances to the next slide, resetting auto-slide interval.
     */
    function nextSlide() {
      index++;
      showSlide();
      resetAutoSlide();

      if (index >= totalSlides + 1) {
        setTimeout(() => {
          slides.style.transition = "none";
          index = 1;
          showSlide(false);
        }, 900);
      }
    }

    /**
     * Goes back to the previous slide, resetting auto-slide interval.
     */
    function prevSlide() {
      index--;
      showSlide();
      resetAutoSlide();

      if (index <= 0) {
        setTimeout(() => {
          slides.style.transition = "none";
          index = totalSlides;
          showSlide(false);
        }, 900);
      }
    }

    /**
     * Resets the auto-slide interval.
     */
    function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      autoSlideInterval = setInterval(nextSlide, 5000);
    }

    // Start auto-slide after a slight delay
    setTimeout(() => {
      autoSlideInterval = setInterval(nextSlide, 5000);
    }, 1000);

    // Attach event listeners to navigation buttons
    container.querySelector(nextButtonSelector).addEventListener('click', nextSlide);
    container.querySelector(prevButtonSelector).addEventListener('click', prevSlide);

    // Swipe functionality
    let startX, endX;
    slides.addEventListener('touchstart', (event) => {
      startX = event.touches[0].clientX;
    });

    slides.addEventListener('touchmove', (event) => {
      endX = event.touches[0].clientX;
    });

    slides.addEventListener('touchend', () => {
      if (startX > endX + 50) {
        nextSlide(); // Swipe left
      } else if (startX + 50 < endX) {
        prevSlide(); // Swipe right
      }
    });

    // Start countdowns for all slides immediately
    startCountdownsForAllSlides();
  }
}

// Initialize sliders on page load
document.addEventListener('DOMContentLoaded', function () {
  // Initialize hero banner carousels
  document.querySelectorAll('.hero-banner-carousel-slider').forEach(container => {
    initializeSlider(container, '.hero-banner-carousel-next', '.hero-banner-carousel-prev', '.hero-banner-carousel-slides', '.hero-banner-carousel-slide');
  });

  // Initialize other sliders
  document.querySelectorAll('.slider-container').forEach(container => {
    initializeSlider(container, '.arrow-right', '.arrow-left', '.slides', '.slide');
  });
  
});

/* * hero carousel banner and promotion bar slider code ( end ). */


/* 
* code to handle play button on video in product details section feature (start) 
*/
document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('titanBrandVideo');
  const playButton = document.getElementById('playButton');

  // Show play button initially
  playButton ? playButton.style.display = 'flex' : '';

  /**
   * Toggle play/pause state of the video and update the visibility of the play button.
   */
  function togglePlayPause() {
      if (video.paused) {
          video.play();
          hidePlayButton();
      } else {
          video.pause();
          showPlayButton();
      }
  }

  // Helper functions to manage play button visibility
  function showPlayButton() {
      // playButton.style.display = 'flex';
    playButton ? playButton.style.display = 'flex' : '';
  }
  
  function hidePlayButton() {
      // playButton.style.display = 'none';
    playButton ? playButton.style.display = 'none' : '';
  }

  // Event listeners for play/pause functionality
  [playButton, video].forEach((element) => {
      if(element){
        element.addEventListener('click', (event) => {
          event.preventDefault();
          togglePlayPause();
        });
    
        element.addEventListener('touchend', (event) => {
            event.preventDefault();
            togglePlayPause();
        });
      }
  });

  // Event listeners for video state changes
  if (video) {
      video.addEventListener('pause', showPlayButton);
      video.addEventListener('play', hidePlayButton);
      video.addEventListener('canplay', () => {
          if (video.paused) {
              showPlayButton(); // Show play button only when the video is paused and ready to play.
          }
      });
  }
});
/* * code to handle play button on video in product details section feature (start) */

// code to set underline in product description on PDP (start)
 document.querySelectorAll('div#descTextBlock a').forEach(function(anchor) {
  anchor.style.textDecoration = 'underline';
  anchor.style.color = 'rgba(var(--color-foreground))';
});
// code to set underline in product description on PDP (end)


/**
  * Calculates time difference between current time and countdown end time.
  *
  * @param {number} countDownDateTime - Timestamp for the countdown in milliseconds.
  * @returns {Object|null} Time difference in hours, minutes, and seconds or null if expired.
  */
  function calculateTimeDifference(countDownDateTime) {
      const currentTime = new Date().getTime();
      const difference = countDownDateTime - currentTime;
  
      if (difference < 0) return null;
  
      const daysCalc = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hoursCalc = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesCalc = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const secondsCalc = Math.floor((difference % (1000 * 60)) / 1000);
  
      const totalHours = daysCalc * 24 + hoursCalc;
      const formattedTime = {
          hours: String(totalHours).padStart(2, "0"),
          minutes: String(minutesCalc).padStart(2, "0"),
          seconds: String(secondsCalc).padStart(2, "0")
      };
  
      return formattedTime;
  }
  
  /**
  * Updates the countdown timer in the given container.
  *
  * @param {number} countDownDateTime - Timestamp for the countdown in milliseconds.
  * @param {HTMLElement} container - Container element for the countdown timer.
  */
  function updateCountdownTimer(countDownDateTime, container) {
      const timeDiff = calculateTimeDifference(countDownDateTime);
  
      if (!timeDiff) {
          // Hide the countdown heading and display timer finished message
          document.querySelectorAll("#countdown-heading").forEach(heading => {
              heading.style.display = "none";
          });
          return;
      }

      container.querySelector("#hours").textContent = `${timeDiff.hours} h :`;
      container.querySelector("#minutes").textContent = `${timeDiff.minutes} m :`;
      container.querySelector("#seconds").textContent = `${timeDiff.seconds} s `;
  }
  
  /**
  * Starts the countdown timer for each valid sales timer.
  */
  function startCountdownTimer() {
      // Get all countdown timer containers
      document.querySelectorAll(".countdown-timer-container").forEach(container => {
          let variantElement = document.getElementById('current-variant-id');
          if (!variantElement) return;
        
          let endTime = variantElement.getAttribute('date-end-time');
          if (!endTime) return;
          
          const endTimestamp = new Date(endTime).getTime();
          if (isNaN(endTimestamp)) return;
         
          if (endTimestamp) {
            // Update timer every second
            const intervalId = setInterval(() => {
                updateCountdownTimer(endTimestamp, container);
                if (endTimestamp <= new Date().getTime()) {
                    clearInterval(intervalId);
                }
            }, 200);
          }
      });
  }

  function handleLabelClick() {
    setTimeout(() => {
      startCountdownTimer(); // this is delayed by 1 seconds
    }, 1000);
  }
  document.addEventListener("DOMContentLoaded", () => {
    // Call the function when the DOM is fully loaded
    startCountdownTimer();
    
    // Attach click handlers to radio labels
    document.querySelectorAll(".c-radioInputLabel").forEach(label => {
      label.addEventListener("click", handleLabelClick);
    });
  });